// import ScrollWatcher from "scroll-watcher";
// import AOS from 'aos';
import { tns } from "tiny-slider/src/tiny-slider";
import "tiny-slider/dist/tiny-slider.css";
import GLightbox from "glightbox";

document.addEventListener("DOMContentLoaded", function (event) {

    // const watcher = new ScrollWatcher();
    // let lastScroll = 0;
    // watcher.on("scrolling", function(evt) {
    //     const direction = evt.scrollY - lastScroll;
    //     console.log(evt.scrollY, direction);
    //     if(evt.scrollY > 100 && direction > 0) {
    //         document.body.classList.remove('body--showhead');
    //     } else {
    //         document.body.classList.add('body--showhead');
    //     }
    //     if(evt.scrollY > 200) {
    //         document.body.classList.add('body--scrolled');
    //     } else {
    //         document.body.classList.remove('body--scrolled');
    //     }
    //     lastScroll = evt.scrollY;
    // });

    const lightbox = GLightbox({
        selector: '[data-gallery="gallery"]',
        touchNavigation: true,
        loop: true,
    });

    document.querySelector('[data-behaviour="menubutton"]').addEventListener("click", () => {
        document.body.classList.toggle('body--shownav');
    });

    // Scroll effects
    // AOS.init({
    //     anchorPlacement: 'bottom-bottom',
    //     duration: 600,
    //     easing: 'ease-in-out'
    // });

    // const menuitems = document.querySelectorAll('[data-behaviour="dropdown"]');

    // if(menuitems.length)
    //     [...menuitems].forEach(item => {
    //         item.addEventListener('click', (e) => {
    //             e.preventDefault();
    //             const otherItems = document.querySelectorAll('.header_nav--show-submenu');
    //             otherItems.forEach(otherItem => {
    //                 if(otherItem !== item.parentNode)
    //                     otherItem.classList.remove('header_nav--show-submenu');
    //             })
    //             item.parentNode.classList.toggle('header_nav--show-submenu');
    //         })
    //     })

    // Sliders
    var sliders = document.querySelectorAll('[data-behaviour="slider"]');

    if(sliders.length)
        [...sliders].map(slider => {
            return tns({
                container: slider,
                items: 1,
                slideBy: 'page',
                navAsThumbnails: true,
                nav: false,
                controls: true,
                controlsText: ['&lt;', '&gt;'],
                mouseDrag: true,
                // autoplay: true,
                autoplayTimeout: 5000,
                speed: 800,
                autoplayHoverPause: true,
                autoplayButtonOutput: false,
            });
        })

    const menu_dropdowns = document.querySelectorAll('[data-behaviour="menu-list"]');

    menu_dropdowns.forEach(select => {
        select.addEventListener('change', function() {
            location.href = this.value;
        })
    })

    const showhide = document.querySelectorAll('[data-behaviour="showhide"]');

    showhide.forEach(toggle => {
        toggle.addEventListener('click', function(e) {
            e.preventDefault();
            toggle.parentNode.parentNode.parentNode.classList.toggle('section_item--visible');
        })
    })
});
